module.exports = __webpack_public_path__ + "static/img/3.72819c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/eng/3.png
// module id = xaD0
// module chunks = 0